import React, { useState, useEffect } from 'react';
import CrumbAvatar from './CrumbAvatar';

/**
 * Floating Crumb Icon
 * Big bobbing cupcake you can click anywhere to open chat.
 */
const FloatingCrumbIcon = ({
  onOpenChat,
  className = '',
  size = 150, // make it big
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Nice delayed entrance
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    if (onOpenChat) onOpenChat();
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      } ${className}`}
    >
      {/* Tiny helper text on hover (no button chrome) */}
      {isHovered && (
        <div className="absolute bottom-[calc(100%+10px)] right-0 transform transition-all duration-300 animate-fade-in">
          <div className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-3 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap">
            Hi! I'm Crumb! 🧁 Click to chat!
            <div className="absolute -bottom-1 right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-pink-500"></div>
          </div>
        </div>
      )}

      {/* Character-only clickable area */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Chat with Crumb the Cupcake 🧁"
        aria-label="Open chat"
        // Button with zero chrome
        className="
          relative p-0 m-0 border-none outline-none bg-transparent
          cursor-pointer select-none
          transform transition-transform duration-300
          hover:scale-[1.05] active:scale-95
          animate-bounce-gentle
          focus:outline-none focus:ring-0
        "
        style={{
          width: size,
          height: size,
          // optional soft drop shadow so the character pops a bit without a circle
          filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.35))',		  
        }}
      >
        {/* The avatar fills the whole clickable area */}
        <CrumbAvatar className="w-full h-full pointer-events-none select-none" />
      </button>
    </div>
  );
};

export default FloatingCrumbIcon;

// Add custom CSS classes for animations
const style = document.createElement('style');
style.textContent = `
  @keyframes bounce-gentle {
    0%, 20%, 53%, 80%, 100% {
      transform: translateY(0px) rotate(0deg);
    }
    40% {
      transform: translateY(-8px) rotate(-2deg);
    }
    43% {
      transform: translateY(-8px) rotate(-2deg);
    }
    70% {
      transform: translateY(-4px) rotate(1deg);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-bounce-gentle {
    animation: bounce-gentle 3s ease-in-out infinite;
  }

  .animate-fade-in {
    animation: fade-in 0.3s ease-out;
  }
`;

// Only add the style if it doesn't exist
if (!document.querySelector('#crumb-animations')) {
  style.id = 'crumb-animations';
  document.head.appendChild(style);
}
